import { useSwapContext } from "@src/contexts";
import { useEffect, useMemo } from "react";
import { HistoryRow } from "./HistoryEntry/HistoryRow";
import { groupHistoryByDate } from "@src/utils/groupHistoryByDate";
import { Navigation, PageLayout, Spinner } from "@src/components";
import { RoutePath } from "@src/interfaces";
import { BackArrowIcon } from "@src/assets";
import { useNavigate } from "react-router-dom";

export const HistoryView = () => {
  const navigate = useNavigate();
  const { history, fetchHistory, historyLoadedOnce, setBalancesSnapshots } =
    useSwapContext();
  const groupedHistory = groupHistoryByDate(history);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  const view = useMemo(() => {
    if (!history || history.length === 0) {
      return historyLoadedOnce ? (
        <div className="text-center py-4 text-text_primary text-opacity-60">
          Your history is empty
        </div>
      ) : (
        <div className="flex justify-center w-full py-4 fill-text_primary">
          <Spinner className="w-8 h-8" />
        </div>
      );
    }

    const entries = Object.entries(groupedHistory);

    return (
      <div className="w-full h-full overflow-y-auto flex flex-col gap-4">
        {entries.map(([date, transactions]) => (
          <div className="flex flex-col items-start" key={date}>
            <p className="font-medium text-text_primary text-sm text-opacity-60 w-full leading-3">
              {date}
            </p>
            <div className="w-full my-2 h-[1px] bg-bg_text_primary/10" />
            <div className="flex flex-col gap-1 w-full">
              {transactions.map((t) => (
                <HistoryRow
                  txData={t}
                  key={`${t.uuid || ""}${t.txHash || ""}${t.tokenAddress}`}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }, [history, historyLoadedOnce, groupedHistory]);

  return (
    <PageLayout
      navigation={
        <Navigation
          leftItems={[
            {
              content: <BackArrowIcon />,
              path: RoutePath.Wallet,
              onClick: () => {
                setBalancesSnapshots({});
                navigate(RoutePath.Wallet);
              },
            },
            {
              content: "History",
              disabled: true,
              path: RoutePath.History,
            },
          ]}
        />
      }
    >
      <div className="h-full overflow-hidden">{view}</div>
    </PageLayout>
  );
};
